// ==============================|| STEP-UP ||============================== //
//
// A 403 `step_up_required` is not an error page. The axios layer raises this event, the global
// StepUpDialog opens, and the original call rejects with a typed error so its caller can stay quiet
// — the user repeats the action after confirming.

export class StepUpRequiredError extends Error {
  readonly code = 'step_up_required';

  constructor() {
    super('Step-up authentication required');
    this.name = 'StepUpRequiredError';

    // Keeps `instanceof` working when compiled to ES5.
    Object.setPrototypeOf(this, StepUpRequiredError.prototype);
  }
}

type Listener = () => void;

const listeners = new Set<Listener>();

export const onStepUpRequired = (listener: Listener): (() => void) => {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
};

export const requestStepUp = (): void => {
  listeners.forEach((listener) => listener());
};
